import { listMailOrderCautiously } from 'models/prescription-fills/helpers';

export default ({shouldMerge = true} = {}) => {
  return listMailOrderCautiously({shouldMerge});
};
